import { useTreatments } from '@splitsoftware/splitio-react';

export const useMrc = (): boolean => {
  const split = 'www_mrc';
  const {
    [split]: { treatment }
  } = useTreatments([split]);
  return treatment === 'on';
};
